export default "__VITE_ASSET__oUqoljG7__"